/**
 * ACL do menu Especial — features por cliente (não globais).
 * Fonte: GET /especial/acl → { sessp: true, ... }
 */
import { getSialApiHost } from '../api.js';

/**
 * @returns {Promise<Record<string, boolean>>}
 */
export async function fetchEspecialAcl() {
	try {
		const res = await fetch(`${getSialApiHost()}/especial/acl`, { credentials: 'include' });
		if (!res.ok) return {};
		const data = await res.json();
		return data && typeof data === 'object' ? data : {};
	} catch {
		return {};
	}
}

/**
 * Mostra só os ramos do Especial cuja ACL o usuário tem.
 * Sem nenhum cliente visível, o item Especial some.
 * @param {Record<string, boolean>} acl
 */
export function applyEspecialMenuAcl(acl = {}) {
	const root = document.querySelector('[data-especial-root]');
	if (!root) return;
	document.querySelectorAll('[data-especial-tenant]').forEach((el) => {
		const key = el.getAttribute('data-especial-tenant');
		el.hidden = !acl[key];
	});
	const visible = root.querySelector('[data-especial-tenant]:not([hidden])');
	root.hidden = !visible;
}

/**
 * @param {string} tenant
 * @param {Record<string, boolean>} acl
 */
export function hasEspecialTenant(tenant, acl = {}) {
	return Boolean(acl[tenant]);
}
